import Button from "./Button";
import { Link } from "react-router-dom";

const Card = ({ img, item }) => {
  const { name, highlight, description, type, id } = item;

  return (
    <div class="flex justify-center">
      <div class="block max-w-sm bg-white shadow-lg">
        <Link
          to={`/${type}/${id}`}
          onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
        >
          <img src={highlight} alt="" />
        </Link>
        <div class="p-6">
          <h5 class="mb-2 text-xl font-medium leading-tight text-neutral-800 font-oswald">
            {name}
          </h5>
          <p class="mb-4 text-base text-neutral-600 line-clamp-3">{description}</p>
          <Button to={`/${type}/${id}`}>Saiba mais</Button>
        </div>
      </div>
    </div>
  );
};

export default Card;
